export default "__VITE_ASSET__CVsxZzy9__"